import produce from 'immer';

import { Action } from '../../actions';
import { State, VideoCreatorListState } from '../../typings/state';
import { SET_VIDEO_CREATOR_MY_VIDEO_LIST } from '../VideoCreatorMyVideoPage/actions';

import { SET_VIDEO_CREATOR_TEMPLATE_LIST } from './actions';

export const videoCreatorListInitialState: VideoCreatorListState = {
    templateList: [],
    myVideoList: [],
    loadingStatus: {
        myVideo: true,
        templatesList: true
    }
};

export function videoCreatorList(
    state: VideoCreatorListState = videoCreatorListInitialState,
    action: Action,
    fullState: State
): VideoCreatorListState {
    switch (action.type) {
        case SET_VIDEO_CREATOR_TEMPLATE_LIST:
            return produce(state, draftState => {
                draftState.templateList = action.list;
                draftState.loadingStatus.templatesList = false;
            });

        case SET_VIDEO_CREATOR_MY_VIDEO_LIST:
            return produce(state, draftState => {
                draftState.myVideoList = action.videoList;
                draftState.loadingStatus.myVideo = false;
            });

        default:
            return state;
    }
}
